import { render, staticRenderFns } from "./ViberPartnerTariffs.vue?vue&type=template&id=0d65ebc9&"
import script from "./ViberPartnerTariffs.vue?vue&type=script&lang=ts&"
export * from "./ViberPartnerTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports